import Data from "../../data/Data";
export default class FormUtils {
    static getNewMiniAppStatus = miniapp => {
        const miniAppDeepClone = JSON.parse(JSON.stringify(miniapp));
        const status = Data.getMiniAppStatus();
        miniAppDeepClone.status =
            miniapp.status && miniapp.status === status.STATUS_ACTIVE
                ? status.STATUS_INACTIVE
                : status.STATUS_ACTIVE;

        return miniAppDeepClone;
    };

    static handleSwitchChange = (name, miniapp) => {
        const miniAppDeepClone = JSON.parse(JSON.stringify(miniapp));
        miniAppDeepClone[name] = !miniapp[name];
        return miniAppDeepClone;
    };

    static getMiniAppWithNewPermissions = (str, miniapp) => {
        const miniAppDeepClone = JSON.parse(JSON.stringify(miniapp));
        let permissions = miniAppDeepClone.permissions;
        if (!permissions) {
            miniAppDeepClone.permissions = [str];
        } else {
            const isRepeatedPermission =
                permissions.filter(permission => permission === str).length > 0;
            isRepeatedPermission
                ? permissions.splice(permissions.indexOf(str), 1)
                : permissions.push(str);
        }

        return miniAppDeepClone;
    };

    static changeSelect = (miniApp, attribute, value) => {
        let miniAppDeepClone = JSON.parse(JSON.stringify(miniApp));
        miniAppDeepClone[attribute].mode = value;
        return miniAppDeepClone;
    };
}
